import { render, staticRenderFns } from "./OrderingSetting.vue?vue&type=template&id=881304d6&scoped=true"
import script from "./OrderingSetting.vue?vue&type=script&lang=js"
export * from "./OrderingSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881304d6",
  null
  
)

export default component.exports